// Recovered compiled webpack factory 2471. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "interpolateAs", {
      enumerable: !0,
      get: function () {
        return o;
      },
    }));
  let n = r(92385),
    a = r(98156);
  function o(e, t, r) {
    let o = "",
      i = (0, a.getRouteRegex)(e),
      s = i.groups,
      l = (t !== e ? (0, n.getRouteMatcher)(i)(t) : "") || r;
    o = e;
    let u = Object.keys(s);
    return (
      u.every((e) => {
        let t = l[e] || "",
          { repeat: r, optional: n } = s[e],
          a = "[" + (r ? "..." : "") + e + "]";
        return (
          n && (a = (t ? "" : "/") + "[" + a + "]"),
          r && !Array.isArray(t) && (t = [t]),
          (n || e in l) &&
            (o =
              o.replace(
                a,
                r ? t.map((e) => encodeURIComponent(e)).join("/") : encodeURIComponent(t),
              ) || "/")
        );
      }) || (o = ""),
      { params: u, result: o }
    );
  }
}
